import { useEffect, useMemo } from 'react';
import { useForm } from '@mantine/form';
import { PBROption } from '@/app/assets/actions/importOptions';

const defaultValues = new Map([
  ['boolean', '0'],
  ['text', ''],
]);

export const usePBRSettingsForm = (pbrOptions: PBROption[]) => {
  const form = useForm({
    transformValues: (values) =>
      Object.entries(values).reduce((acc, [key, value]) => ({ ...acc, [key]: value === '' ? null : value }), {}),
  });

  useEffect(() => {
    if (!pbrOptions || !pbrOptions.length) {
      return;
    }
    const initialValues = pbrOptions.reduce(
      (acc, next) => ({
        ...acc,
        [next.config.property]: next.options.default ?? defaultValues.get(next.type),
      }),
      {} as Record<string, any>
    );

    form.setValues(initialValues);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pbrOptions]);

  return {
    form,
  };
};
